import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IInssState } from './store/inss.state';
import { setInssAction } from './store/inss.actions';
import { getInssSelectors } from './store/inss.selectors';
import { IInssData } from 'src/app/modules/interfaces/inss.interface';
import { InssService } from 'src/app/services/inss.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-inss-retirement',
  templateUrl: './inss-retirement.component.html',
  styleUrls: ['./inss-retirement.component.scss'],
})
export class InssRetirementComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();

  formsId: number;
  inssData: IInssData = {
    id: 0,
    has_contribute: null,
    montly_value: null,
    believes_inss_sufficient: null,
    passive_retirement_income: null,
  };

  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IInssState>;
  dataState: IInssState;
  validateContribute: boolean = false;

  constructor(private store: Store, private inssService: InssService) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadInssData();
  }

  loadInssData(): void {
    this.isLoading = true;
    this.inssService.getInssData(this.formsId).subscribe((response) => {
      if (response) {
        this.inssData = {
          id: response.id,
          has_contribute: response.has_contribute,
          montly_value: response.montly_value || null,
          believes_inss_sufficient: response.believes_inss_sufficient,
          passive_retirement_income:
            response.passive_retirement_income || null,
        };
        this.saveState()
      }
    });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: Partial<IInssData> = {
      has_contribute: this.inssData.has_contribute,
      montly_value: this.inssData.montly_value,
      believes_inss_sufficient: this.inssData.believes_inss_sufficient,
      passive_retirement_income: this.inssData.passive_retirement_income,
    };

    this.inssService
      .updateInssData(this.formsId, this.inssData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState()
          this.formSaved.emit();
        },
        error: () => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
        },
      });
  }

  saveState(): void {
    this.dataState = {
      ...this.dataState,
      check: true,
      contribute: this.inssData.has_contribute === 1,
      retirement: this.inssData.believes_inss_sufficient === 1,
      amountRetirement: this.inssData.passive_retirement_income || 0,
      amountMonth: this.inssData.montly_value || 0,
    };

    this.setState(this.dataState);
  }

  updateAmount(event: number, field: keyof IInssData): void {
    this.inssData = {
      ...this.inssData,
      [field]: event,
    };
    this.onFieldChange();
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  startTrial(): void {
    this.setState(this.dataState);
  }

  setState(data: IInssState) {
    this.store.dispatch(setInssAction(data));
    this.isLoading = false;
  }

  getState() {
    this.dataState$ = this.store.select(getInssSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = false;
    if (this.dataState.retirement != undefined) {
      this.dataState.check = true;
    }
    this.setState(this.dataState);
    this.validateContribute = !this.dataState.contribute;
  }
}
